// Un masquage n'émet `hideComplete` qu'une fois : sans ça, chaque re-render de l'élément masqué
// (hook `updated`) relancerait le timer et l'événement.
const hideTimers = new WeakMap();

export const hide = {
  mounted: function (el, binding, vnode) {
    hideEl(el, binding, vnode);
  },
  updated: function (el, binding, vnode) {
    hideEl(el, binding, vnode);
  },
  unmounted: function (el) {
    cancelHide(el);
  },
};

function cancelHide(el) {
  clearTimeout(hideTimers.get(el));
  hideTimers.delete(el);
}

function hideEl(el, binding, vnode) {
  if (binding.value.enabled === false) {
    cancelHide(el);
    el.classList.remove("hide-element", "-isHiding");
    return;
  }
  const duration = binding.value.duration ? binding.value.duration : 300;
  const transition = binding.value.transition ? binding.value.transition : "fade";
  el.classList.add("hide-element");
  const hide = binding.value.hide;
  if (!hide) {
    cancelHide(el);
    // Un défilement interne survenu pendant l'animation (conteneur réduit à 0, overflow hidden) survit à la restauration.
    if (el.classList.contains("-isHiding")) {
      el.scrollTop = 0;
    }
    el.classList.remove("-isHiding");
    el.style.setProperty("--element-max-height", el.offsetHeight + "px");
  }
  el.style.setProperty("--element-animation-duration", duration + "ms");
  el.style.setProperty("--element-transition-type", "hide-transition-" + transition);
  if (hide) {
    el.classList.add("-isHiding");
    if (hideTimers.has(el)) {
      return;
    }
    hideTimers.set(
      el,
      setTimeout(() => {
        hideTimers.set(el, null);
        const evt = new CustomEvent("hideComplete");
        vnode.el.dispatchEvent(evt);
      }, duration),
    );
  }
}
